import React, {useState} from 'react';
import styled from 'styled-components/native';
import MainLayout from '../../mainLayout';
import {RouteProp, useRoute} from '@react-navigation/native';
import {FileViewerRouteParams} from '../../../interfaces/api/content/home';
import {showGlobalToast} from '../../../connected-components/toast/actions';
import {tr} from '../../../translations';
import WebView from 'react-native-webview';
import Loader from '../../../components/loader';
import Animated, {ZoomInRotate, ZoomOutRotate} from 'react-native-reanimated';
import TextGeneric from '../../../components/textGeneric';
import {getFileViewerUrlAndFormat, openUrl} from '../../../utils/helpers';
import lightTheme from '../../../theme/lightTheme';
import {Dimensions, Platform, StatusBar, View} from 'react-native';
import Pdf from '../../../utils/pdf';
import {ScreenProps} from '../../../interfaces/screens/mainScreen';
import {useCustomHeaderHeight} from '../../../utils/hooks/useHeaderHeight';
import {ToastType} from '../../../utils/enums';
import useResponsiveDimensions from '../../../utils/hooks/useResponsiveDimensions';
import {isWeb} from '../../../utils/responsive';

const Container = styled.View<{responsiveWidth: number}>`
  width: ${({responsiveWidth}) => responsiveWidth}px;
  height: ${isWeb
    ? '100%'
    : Dimensions.get('screen').height - (StatusBar.currentHeight || 0) + 'px'};
  align-self: center;
  align-items: center;
`;
const LoaderContainer = styled(Animated.View)<{responsiveWidth: number}>`
  width: ${({responsiveWidth}) => responsiveWidth}px;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const Text = styled(TextGeneric)`
  padding-top: 4%;
  font-size: ${({theme}) => theme.text.s7}px;
  color: ${({theme}) => theme.text.dark};
`;
const PdfContainer = styled(Pdf)`
  width: 100%;
  height: 100%;
`;

const injectedJS = `
    setTimeout(function() {
      window.ReactNativeWebView.postMessage(
        document.documentElement.scrollHeight.toString()
      );
    }, 100);
    document.body.style.backgroundColor = '${lightTheme.homeBackground}';
    document.documentElement.style.backgroundColor = '${lightTheme.homeBackground}';
  `;

const FileViewer: React.FC<ScreenProps> = ({navigation}) => {
  const headerHeight = useCustomHeaderHeight();
  const {hdp, wdp} = useResponsiveDimensions();
  const {tab_name, title, fileUrl, pdf_link, pdf} = useRoute<
    RouteProp<FileViewerRouteParams>
  >().params || {
    tab_name: 'PDF',
    pdf: '',
    pdf_link: '',
    fileUrl: '',
  };
  const file = fileUrl || pdf_link || pdf || '';
  const {fileFormat, viewerUrl} = getFileViewerUrlAndFormat(file);
  const [webViewHeight, setWebViewHeight] = useState(
    hdp(100) - (headerHeight || 0),
  );
  const cacheFileName = file.split('/').slice(3).join('_');
  return (
    <MainLayout
      showOverlay={false}
      backHeader
      title={tab_name || title || 'GENIO Document'}
      noPaddingHeader
      enableScroll={false}>
      <Container responsiveWidth={wdp(100)}>
        {fileFormat === 'pdf' ? (
          <PdfContainer
            trustAllCerts={false}
            source={{uri: file, cache: true, cacheFileName}}
            // onLoadProgress={() => startLoading()}
            // onLoadComplete={() => finishLoading()}
            onError={(error: any) => {
              navigation?.goBack();
              showGlobalToast({
                message: tr('app.error'),
                type: ToastType.ERROR,
              });
            }}
            onPressLink={(uri: string) => openUrl(uri)}
          />
        ) : (
          <WebView
            style={{
              width: wdp(100),
              minHeight: hdp(100) - (headerHeight || 0),
              height: webViewHeight,
              alignSelf: 'center',
              backgroundColor: lightTheme.homeBackground,
            }}
            source={{
              uri: viewerUrl,
            }}
            renderLoading={() => (
              <LoaderContainer
                responsiveWidth={wdp(100)}
                entering={ZoomInRotate}
                exiting={ZoomOutRotate}>
                <Loader />
                <Text>{tr('app.loading')}</Text>
              </LoaderContainer>
            )}
            onError={() => {
              showGlobalToast({
                message: tr('app.error'),
                type: ToastType.ERROR,
              });
            }}
            trustAllCerts={Platform.OS === 'ios'}
            startInLoadingState
            cacheEnabled
            javaScriptEnabled
            automaticallyAdjustsScrollIndicatorInsets
            showsVerticalScrollIndicator
            scrollEnabled
            scalesPageToFit
            injectedJavaScript={injectedJS}
            onMessage={event => {
              const height = parseInt(event.nativeEvent.data, 10);
              setWebViewHeight(height);
            }}
          />
        )}
      </Container>
    </MainLayout>
  );
};
export default FileViewer;
